import { assertLast } from '@mntn-dev/utilities'
import type { AnyValue } from '@mntn-dev/utility-types'

import type { AnyRoute } from '../route.ts'
import { findRouteAncestry } from './find-route-ancestry.ts'

export const findValidRouteFromAncestryWithParams = (
  route: AnyRoute | undefined,
  params: AnyValue
): AnyRoute => {
  const routeAncestry = findRouteAncestry(route, {
    includeSelf: true,
  }).reverse()

  const paramsReplacedRoute = routeAncestry
    .find((route) => route.params(params).isValid())
    ?.params(params)

  return paramsReplacedRoute ? paramsReplacedRoute : assertLast(routeAncestry)
}
